import { getCompStyleProp, getTranslateX, remToPx } from "../inc/helpers";


export default class Marquee {
    constructor({
        container,
        entries,
        btn,
        speed = 2000,
    }) {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;        

        this._size = this._entries.length;

        if (!this._speed)
            this._speed = speed;
        
        this._dir = this._container.dataset?.dir ?? "rtl";
        this._timeout, this._resizing;                    
        this._playing = true;        
        this._stopped = false;

        this._init();        
    }

    _init() {
        this._entries.forEach(entry => this._container.appendChild(entry.cloneNode(true)));
        this._setupProps();
        window.addEventListener("resize", this._onResize.bind(this));

        const [lblActive, lblInactive] = [
            this._btn?.dataset?.lblActive,
            this._btn?.dataset?.lblInactive,
        ];
        this._btn?.addEventListener("click", () => {                        
            if (!this._stopped) {                
                this._pause();
                if (!this._btn.classList.contains("is-active"))
                    this._btn.classList.add("is-active");
                this._btn.setAttribute("aria-label", lblActive);                
                this._stopped = true;

                return;
            }            

            this._stopped = false;
            this._play();
            this._btn.classList.remove("is-active");      
            this._btn.setAttribute("aria-label", lblInactive);            
        });              
    }

    _setupProps() {
        this._gap = remToPx("--gap-400");
        this._s = this._size * (this._speed / 1000);        
        this._sum = Array.from(this._entries).reduce((sum, entry) => sum + entry.offsetWidth, 0);        
        this._w = this._sum * 2 + (this._gap * (this._container.children.length - 1));
        this._t = 
            (this._sum + (this._gap * this._entries.length)) * -1;
    }

    _onResize() {
        this._pause();
        clearTimeout(this._resizing);
        this._resizing = setTimeout(() => {
            this._setupProps();
            this._play();
        }, 250);
    }

    _pause() {
        if (this._stopped) return;
        clearTimeout(this._timeout);
        
        const _t = getCompStyleProp("transform", this._container);
        const t = getTranslateX(_t) 

        this._container.style.removeProperty("--s");
        this._container.style.setProperty("--t", `${t}px`);

        this._playing = false;
    }

    _play() {
        if (this._stopped) return;

        clearTimeout(this._timeout);
        const _t = getCompStyleProp("transform", this._container);
        const t = getTranslateX(_t);

        if (this._dir === "rtl") {
            const s = (this._s * t) / this._t;

            this._container.style.setProperty("--s", `${this._s - s}s`);
            this._container.style.setProperty("--t", `${this._t}px`);

        } else {        
            const s = (this._s * (this._t - t)) / this._t;

            this._container.style.setProperty("--s", `${this._s - s}s`);
            this._container.style.setProperty("--t", "0px");
        }

        this._playing = true;
    }        

    init() {
        let start;
        const animate = (timestamp) => {
            if (start === undefined) 
                start = timestamp;
            
            const elapsed = timestamp - start;
            
            if (elapsed < 1) {
                this._handleStart();
                requestAnimationFrame((t) => animate(t));
                
            } else {
                this._dir === "rtl"
                ? this._handleRtl()
                : this._handleLtr();
            }
        }

        this._container.addEventListener("transitionend", this._onTransitionEnd.bind(this));        
        requestAnimationFrame(animate);
    }

    _handleStart() {
        if (this._dir === "rtl") {
            this._container.style.setProperty("--w", `${this._w}px`);
            this._container.style.setProperty("--s", `${this._s}s`);

        } else {
            this._container.style.setProperty("--w", `${this._w}px`);        
            this._container.style.setProperty("--t", `${this._t}px`);
        }
    }    
    
    _handleRtl() {
        this._container.style.setProperty("--t", `${this._t}px`);
    }

    _handleLtr() {
        this._container.style.setProperty("--s", `${this._s}s`);
        this._container.style.setProperty("--t", "0px");
    }

    _onTransitionEnd() {
        if (this._dir === "rtl") {
            this._container.style.removeProperty("--s");
            this._container.style.removeProperty("--t");

            clearTimeout(this._timeout);
            this._timeout = setTimeout(() => {
                this._container.style.setProperty("--s", `${this._s}s`);
                this._container.style.setProperty("--t", `${this._t}px`);   
            }, 0);

        } else {
            this._container.style.removeProperty("--s");
            this._container.style.setProperty("--t", `${this._t}px`);
                        
            clearTimeout(this._timeout);
            this._timeout = setTimeout(() => {
                this._container.style.setProperty("--s", `${this._s}s`);
                this._container.style.setProperty("--t", "0px");   
            }, 0);
        }
    }
}